import axios, { AxiosRequestConfig } from 'axios';
import { authHeader } from '../helpers/authHeader';
import { routeConstants } from '../routes/route.constants';
import { SHARED_ENDPOINTS } from './endpoints';
import { useHistory } from 'react-router-dom';
import { loginConstants } from '../../modules/login/login.constants';

export const authService = {
    logout,
};

const instance = axios.create();

async function logout() {
    const requestOptions: AxiosRequestConfig = {
        url: SHARED_ENDPOINTS.LOGOUT.url,
        method: routeConstants.METHODS.POST,
        headers: authHeader(),
    };

    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');

    const history = useHistory();
    history.push(loginConstants.ROUTES.LOGIN);

    await instance.request(requestOptions);
}
